/**
 * Logger Utility
 *
 * Provides controlled logging that:
 * - Only logs in development mode (console.log)
 * - Always logs errors (console.error) for production debugging
 * - Can be extended to send logs to external services (Sentry, LogRocket, etc.)
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  /**
   * Log general information (development only)
   * Use for debugging, state changes, flow tracking
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log errors (always logged, even in production)
   * Use for error tracking and debugging
   */
  error: (...args) => {
    console.error(...args);
    // TODO: Send to error tracking service in production
    // Example: if (!isDevelopment) Sentry.captureException(args[0]);
  },

  /**
   * Log warnings (development only)
   * Use for deprecated features, potential issues
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Log info messages (development only)
   * Use for important state transitions, user actions
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Log debug messages (development only)
   * Use for verbose debugging, data inspection
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

export default logger;
